import React from 'react';

import { Text } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import Picture from 'components/picture';
import { Box, BoxProps } from 'components/ui';
import { useIsDesktopBreakpoint } from 'hooks/use-media-query';

const MOBILE_SAFETY_MEASURE = '100px';
const PRODUCT_IMAGE_HEIGHT_MOBILE = '300px';
const PRODUCT_IMAGE_HEIGHT_DESKTOP = '350px';

type ProductOverviewContainerProps = BoxProps & {
  withSpacing: boolean;
};

export const ProductOverviewContainer = ({
  style,
  withSpacing,
  ...props
}: ProductOverviewContainerProps) => {
  const isDesktop = useIsDesktopBreakpoint();

  return (
    <Box
      {...props}
      style={[
        styles.productOverviewContainer,
        withSpacing && styles.productOverviewContainerWithSpacing,
        withSpacing && isDesktop && styles.productOverviewContainerWithSpacingDesktop,
        style,
      ]}
    />
  );
};

export const ProductImage = Picture.withConfig({
  width: 'full',
  height: { base: PRODUCT_IMAGE_HEIGHT_MOBILE, md: PRODUCT_IMAGE_HEIGHT_DESKTOP },
  minHeight: { base: MOBILE_SAFETY_MEASURE, md: 0 },
  objectFitContain: true,
});

export const ProductInformationContainer = ({ style, ...props }: BoxProps) => (
  <Box {...props} style={[styles.productInformationContainer, style]} />
);

export const ProductTitle = Text.withConfig({
  variant: 'headerTwo',
  margin: 0,
  fontSize: '2xl',
  lineHeight: 'md',
  paddingY: '12px',
  paddingX: '$8',
  textAlign: 'center',
});

const styles = StyleSheet.create({
  productInformationContainer: {
    alignItems: 'center',
    alignSelf: 'center',
    paddingHorizontal: 16,
    width: '100%',
  },
  productOverviewContainer: {
    paddingBottom: 0,
    width: '100%',
  },
  productOverviewContainerWithSpacing: {
    paddingBottom: 12,
  },
  productOverviewContainerWithSpacingDesktop: {
    paddingBottom: 32,
  },
});
